export default {
  en: {
    snack: {
      copied: 'Copied',
    },
  },
};
